/**
 * Model used by the ModelFetcher to keep track of a model.  Has little use outside of that application.
 */
import Backbone from 'backbone';

var TrackedModel = Backbone.Model.extend({
    defaults: {
        required: false, // If true, this model is required before the parent fetcher can fire FETCH_COMPLETE
        model: null, // The model being tracked.
        success: null, // Fired if this model's fetch succeeded.
        error: null, // Fired if this model's fetch errored off.
        countError: false // If true, a failure to load this resource is still counted.
    },

    initialize: function(options) {
        this.options = options;
    }
});

export default TrackedModel;
